import {
  PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_BEGIN,
  PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_SUCCESS,
  PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_FAILURE,
  PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_DISMISS_ERROR,
} from './constants'
import { BFFAgent } from '../../../common/BFFAgent'

export function getCuotaPromedioAndCft(credit_line_id, tna, montoFinanciar, quantity, avgQuoteValue, calculateAvgQuote, valorPrimeraCuota, quebrantoPorc, gastosFijos) {
  return async (dispatch) => {
    dispatch({
      type: PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_BEGIN,
    })

    const body = {
      credit_line_id,
      tna,
      montoFinanciar,
      quantity,
      avgQuoteValue,
      calculateAvgQuote,
      valorPrimeraCuota,
      quebrantoPorc,
      quebranto: gastosFijos
    }

    try {
      const data = await BFFAgent.Presupuestador.getCftQuoteAvg(body)
      
      dispatch({
        type: PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_SUCCESS,
        data: {
          cft: data.cft,
          cuotaProm: data.coutaProm,
          valorPrimeraCuota: data.valorPrimeraCuota
        },
      })
    }
    catch (err) {
      dispatch({
        type: PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_FAILURE,
        data: { error: err },
      })
    }
  }
}

export function dismissGetCuotaPromedioAndCftError() {
  return {
    type: PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getCuotaPromedioAndCftPending: true,
        getCuotaPromedioAndCftError: null,
      }

    case PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_SUCCESS:
      // The request is success
      return {
        ...state,
        getCuotaPromedioAndCftPending: false,
        getCuotaPromedioAndCftError: null,
        ...action.data,
      }

    case PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_FAILURE:
      // The request is failed
      return {
        ...state,
        getCuotaPromedioAndCftPending: false,
        getCuotaPromedioAndCftError: action.data.error,
      }

    case PRESUPUESTADOR_GET_CUOTA_PROMEDIO_AND_CFT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getCuotaPromedioAndCftError: null,
      }

    default:
      return state
  }
}
